module.exports = __webpack_public_path__ + "img/10_mak.f81881cf.jpg";